import React, { useState } from 'react';
import { Tabs } from 'antd';

import AppRoutes from '../routes/AppRoutes';
import Charts from './Charts';
import NavigationPage from './NavigationPage';

const NavigationTabs = () => {
  const [activeTab, setActiveTab] = useState('navigation');

  const items = [
    {
      key: 'navigation',
      label: 'Navigation',
      children: <NavigationPage onNavigate={() => setActiveTab('page')} />,
    },
    {
      key: 'charts',
      label: 'Charts',
      children: <Charts />,
    },
    {
      key: 'page',
      label: 'Page',
      children: <AppRoutes />,
    },
  ];

  return (
    <div className="mx-3">
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        destroyInactiveTabPane={false}
      />
    </div>
  );
};

export default NavigationTabs;
